import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import { categories } from '@/mocks/categories';
import { topics } from '@/mocks/topics';

const bubbleTone: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50',
  accent: 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50',
  secondary: 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50',
};

export default function CategoriesSection() {
  return (
    <section id="categories" className="w-full border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionTitle
          eyebrow="Topic Map"
          title="按主题找你想看的那一类"
          desc="不同领域的爆料，求证方式也不一样。选一个方向，看看这类传言通常会在哪里露出破绽。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category) => {
            const count = topics.filter((topic) => topic.categoryId === category.id).length;
            return (
              <Link
                key={category.id}
                to={`/topics?category=${category.id}`}
                className="group flex items-start gap-4 rounded-xl border border-background-200 bg-background-100/50 p-5 transition-colors hover:border-foreground-300 hover:bg-background-100"
              >
                <span
                  className={`flex h-12 w-12 flex-none items-center justify-center rounded-lg transition-colors ${bubbleTone[category.color]}`}
                >
                  <i className={`${category.icon} text-xl`}></i>
                </span>
                <span className="flex flex-col">
                  <span className="flex items-center gap-2">
                    <span className="font-heading text-base font-semibold text-foreground-950">{category.name}</span>
                    <span className="rounded-full bg-background-200 px-2 py-0.5 font-label text-[11px] text-foreground-700">
                      {count} 条
                    </span>
                  </span>
                  <span className="mt-2 text-sm leading-relaxed text-foreground-600">{category.desc}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}